export const KYCDocList = [

    {
        name: "CERTIFICATE OF INCORPORATION",
        fieldName: "CERTIFICATE OF INCORPORATION",
        description: "This entails evidence of document showing company's name and date of incorporation",
        number: "000001",
        isUnique: false,
        status: "PROFILED",
        category: "LOW",
        documentType: "PDF",
        required: true
    },
    {
        name: "PROOF OF ADDRESS",
        fieldName: "PROOF OF ADDRESS",
        description: "Evidence of document showing company's proof of address",
        number: "000090",
        isUnique: false,
        status: "PROFILED",
        category: "LOW",
        documentType: "PDF",
        required: true
    },
    {
        name: "VALID ID OF A DIRECTOR",
        fieldName: "VALID ID OF A DIRECTOR",
        description: "Government issued document showing bearer's identification detail",
        number: "000002",
        isUnique: false,
        status: "PROFILED",
        category: "LOW",
        documentType: "PDF",
        required: true
    },
    {
        name: "VALID ID OF ANOTHER DIRECTOR",
        fieldName: "VALID ID OF ANOTHER DIRECTOR",
        description: "Government issued document showing bearer's identification detail",
        number: "000014",
        isUnique: false,
        status: "PROFILED",
        category: "LOW",
        documentType: "PDF",
        required: true
    }
];

export const KYCDocList_Tech = [
    {
        name: "CERTIFICATE OF INCORPORATION",
        fieldName: "CERTIFICATE OF INCORPORATION",
        description: "This entails evidence of document showing company's name and date of incorporation",
        number: "000001",
        isUnique: false,
        status: "PROFILED",
        category: "LOW",
        documentType: "PDF",
        required: true
    },
    {
        name: "PROOF OF ADDRESS",
        fieldName: "PROOF OF ADDRESS",
        description: "Evidence of document showing company's proof of address",
        number: "000090",
        isUnique: false,
        status: "PROFILED",
        category: "LOW",
        documentType: "PDF",
        required: true
    }
]